<template>
    <label class="form-radio m-0 flex cursor-pointer items-center gap-x-1.5 select-none">
        <input v-model="model" type="radio" :value="section" class="hidden" />

        <div class="border-2 border-turquoise-light flex size-4 items-center justify-center">
            <div class="bg-turquoise-light/0 size-2.5"></div>
        </div>

        <span class="text-sm text-gray">{{ section.name }}</span>
    </label>
</template>

<script setup>
const model = defineModel({ type: [Boolean, Number, String, Array, Object] });

defineProps({ section: { type: Object, required: true } });
</script>

<style>
@reference '../../../styles/pappasrw.css';

.form-radio:has(:checked) > div div {
    @apply bg-turquoise-light;
}
</style>
